import React from 'react';
import { ECOSYSTEM_LOGOS } from '../../data/dgpt';
import { Reveal } from '../ui/Reveal';
type Logo = (typeof ECOSYSTEM_LOGOS)[number];
function LogoItem({
  logo,
  hidden
}: {
  logo: Logo;
  hidden?: boolean;
}) {
  return <li className="flex shrink-0 items-center justify-center px-8 sm:px-12" aria-hidden={hidden || undefined} data-id="element-453" data-mp="mcp5bglufoze">
      <span className="flex h-12 w-36 items-center justify-center overflow-hidden sm:w-40" data-id="element-454" data-mp="reef6sxbxwlw">
        <img src={logo.src} alt={hidden ? '' : logo.name} width={160} height={48} loading="lazy" decoding="async" style={{
        transform: `scale(${logo.scale})`
      }} className="h-full w-full object-contain opacity-55 mix-blend-multiply grayscale transition-[filter,opacity] duration-200 hover:opacity-100 hover:brightness-[0.35] hover:contrast-[3]" data-id="element-455" data-mp="wb4vnhd1qu7u" />
      </span>
    </li>;
}

/**
 * Single-row infinite logo marquee. Two identical tracks scroll by -50% for a
 * seamless loop; pauses on hover and stops under prefers-reduced-motion.
 */
export function LogoStrip() {
  return <div data-id="element-456" data-mp="1ej3lio2edohz">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-12 sm:px-6 lg:px-8 lg:py-14" data-id="element-457" data-mp="1eikbrumwi6f1">
        <Reveal data-id="element-458" data-mp="1agqcnqsctagz">
          <h3 className="text-center text-[11px] font-medium uppercase tracking-[0.2em] text-text-tertiary" data-id="element-459" data-mp="1ai9u3kpqxrkc">
            Organizations that have worked with StartupFuel
          </h3>
        </Reveal>
      </div>
      <Reveal delay={0.06} className="dgpt-marquee group relative -mt-4 overflow-hidden pb-12 lg:pb-14" data-id="element-460" data-mp="2274mnbx8y2nd">
        <ul className="dgpt-marquee-track flex w-max items-center group-hover:[animation-play-state:paused]" data-id="element-461" data-mp="1y7clvle3h0sk">
          {ECOSYSTEM_LOGOS.map(logo => <LogoItem key={logo.name} logo={logo} data-id="element-462" data-mp="1oh9gelpsdudc" />)}
          {ECOSYSTEM_LOGOS.map(logo => <LogoItem key={`${logo.name}-dup`} logo={logo} hidden data-id="element-463" data-mp="2lwx7yd5joe62" />)}
        </ul>
      </Reveal>
    </div>;
}